<template>
  <!-- 卡片组件 -->
  <div>
    <div class="card_row">
      <div class="type2_tit" v-if="cardTypeList_type2.length">
        {{ $t("bank_card.Collaborative_Cards") }}
      </div>
      <div
        class="card_box1"
        v-for="item in cardTypeList_type2"
        :key="item.userid"
      >
        <div class="card_box1_top">
          <el-image
            class="card_box1_top_img"
            :src="
              item.card_picture || require('../assets/img/card_tpo_img.png')
            "
            style="max-width: 300px"
          >
            <!-- fit="cover"> -->
          </el-image>
        </div>
        <div class="card_box1_bottom">
          <div class="btm_t1">
            <span>
              <span>{{ item.debit_card_name || "-" }}</span>
              <i
                class="el-icon-question card_info_icon"
                @click="card_fee_btn(item)"
              ></i>
            </span>
          </div>
          <template v-if="item.viewType==1">
            <div class="div_open_addr">
              <span class="open_addr" @click="open_addr">
                {{ $t("bank_card.View_Plan") }}
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="btm_t2">{{ $t("bank_card.Directors_Staffs") }}</div>
            <div class="link_box" v-if="item.viewCopy">
              <div
                class="btm_t3"
                @click="
                  card_dlg_open(item)">
                {{ $t("main.text493") }}
              </div>
              <span class="link_text" @click="copy_link(item)">{{ $t("main.text600") }}</span>
            </div>
            <div v-else>
              <div style="height: 38px;">&nbsp;</div>
              <span>&nbsp;</span>
            </div>
          </template>
          <template v-else>
            <div class="div_open_addr">
              <span class="open_addr" style="cursor: default">&nbsp;</span>
            </div>
            <div class="btm_t2" style="opacity: 0; cursor: default">
              {{ $t("bank_card.Directors_Staffs") }}
            </div>
            <div class="link_box">
              <div
                class="btm_t3"
                style="
                  cursor: default;
                  border: none;
                  padding-left: 0;
                  color: inherit;
                  color: #ffffff;
                  opacity: 0.8;
                "
              >
                <span v-if="item.viewType==2">{{ $t("bank_card.API_Implementation") }}</span>
                <span v-if="item.viewType==3">{{ $t("bank_card.QR_Code_Implementation") }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- <slot name="card_title"> </slot> -->
    <div class="card_row" v-if="company_type != 3">
      <div class="type2_tit" v-if="cardTypeList_type1.length">
        {{ $t("bank_card.FEB_Debit_Cards") }}
      </div>
      <div
        class="card_box1"
        v-for="item in cardTypeList_type1"
        :key="item.userid"
      >
        <div class="card_box1_top">
          <el-image
            class="card_box1_top_img"
            :src="
              item.card_picture || require('../assets/img/card_tpo_img.png')
            "
            style="max-width: 300px"
          >
            <!-- fit="cover"> -->
          </el-image>
        </div>
        <div class="card_box1_bottom">
          <div class="btm_t1">
            <span>
              <span>{{ item.debit_card_name || "-" }}</span>
              <i
                class="el-icon-question card_info_icon"
                @click="card_fee_btn(item)"
              ></i>
            </span>
          </div>
          <template v-if="item.viewType==1">
            <div class="div_open_addr">
              <span class="open_addr" @click="open_addr">
                {{ $t("bank_card.View_Plan") }}
                <i class="el-icon-arrow-right"></i>
              </span>
            </div>
            <div class="btm_t2">{{ $t("bank_card.Directors_Staffs") }}</div>
            <div class="link_box" v-if="item.viewCopy">
              <div
                class="btm_t3"
                @click="
                  card_dlg_open(item)">
                {{ $t("main.text493") }}
              </div>
              <span class="link_text" @click="copy_link(item)">{{ $t("main.text600") }}</span>
            </div>
            <div v-else>
              <div style="height: 38px;">&nbsp;</div>
              <span>&nbsp;</span>
            </div>
          </template>
          <template v-else>
            <div class="div_open_addr">
              <span class="open_addr" style="cursor: default">&nbsp;</span>
            </div>
            <div class="btm_t2" style="opacity: 0; cursor: default">
              {{ $t("bank_card.Directors_Staffs") }}
            </div>
            <div class="link_box">
              <div
                class="btm_t3"
                style="
                  cursor: default;
                  border: none;
                  padding-left: 0;
                  color: inherit;
                  color: #ffffff;
                  opacity: 0.8;
                "
              >
                <span v-if="item.viewType==2">{{ $t("bank_card.API_Implementation") }}</span>
                <span v-if="item.viewType==3">{{ $t("bank_card.QR_Code_Implementation") }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 购买卡片 -->
    <el-dialog
      :title="$t('main.text511')"
      :visible.sync="apply_card_dlg"
      custom-class="dlg element_input card_dlg"
      append-to-body
      width="480px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <div class="card_dlg_t1">
            <img class="card_img1" src="../assets/img/user2.png" alt="" />
            <div class="card_dlg_t2">{{ $t("main.text497") }}</div>
          </div>

          <div class="card_dlg_t1 c_radio_box">
            <div class="list_table">
              <el-radio-group v-model="check_num" @change="checkbox_fun">
                <el-radio label="1">{{ $t("main.text498") }}</el-radio>
                <el-radio label="2">{{ $t("main.text499") }}</el-radio>
                <el-radio label="3">{{ $t("bank_card.Staff") }}</el-radio>
              </el-radio-group>
            </div>
          </div>

          <el-form v-show="check_num == 1">
            <el-form-item>
              <el-select
                v-model="select_num"
                :placeholder="$t('main.text500')"
                @change="select_fun"
              >
                <el-option
                  v-for="(item, index) in select_list"
                  :key="index"
                  :label="item.name"
                  :value="item.director_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="btn_card">
            <el-button
              type="primary"
              class="confirm_btn confirm_btn_card"
              @click="continue_btn"
              >{{ $t("main.text394") }}</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 卡片费用 -->
    <el-dialog
      :title="$t('main.text501')"
      :visible.sync="card_fee_dlg"
      custom-class="dlg element_input card_dlg card_dlg_mobile"
      append-to-body
      width="800px"
    >
      <div class="dlg_body">
        <div class="c_fee_box">
          <!-- <div class="c_f_t1">{{$t('main.text502')}}</div> -->
          <div class="c_tab_box">
            <div class="c_b1">
              <div class="c_b2">{{ $t("new1_txt.U_A_Fee") }}</div>
              <div class="c_b3">{{ feb_config.Annual_Membership_Fee }}</div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("new1_txt.U_C_Fee") }}</div>
              <div class="c_b3">{{ feb_config.Card_Cost }}</div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text505") }}</div>
              <div class="c_b3">{{ feb_config.Inactivity_Fee }}</div>
              <div
                class="c_b1_text"
                style="white-space: pre-line"
                v-html="feb_config.Describe"
              ></div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text506") }}</div>
              <div class="c_b3">{{ feb_config.Card_Activation }}</div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text507") }}</div>
              <div class="c_b3">{{ feb_config.POS_Online_Purchase }}</div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text508") }}</div>
              <div class="c_b3">{{ feb_config.ATM_Withdrawal }}</div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text509") }}</div>
              <div class="c_b3">{{ feb_config.ATM_Balance_Inquiry }}</div>
            </div>

            <!-- <div class="c_b1">
              <div class="c_b2">{{ $t("main.text510") }}</div>
              <div class="c_b3">{{ feb_config.Load_Fee_Contract }}</div>
            </div> -->

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text786") }}</div>
              <div class="c_b3">{{ feb_config.Load_Fee_Direct }}</div>
            </div>

            <div class="c_b1">
              <div class="c_b2">{{ $t("main.text670") }}</div>
              <div class="c_b3">{{ feb_config.Card_Replacement }}</div>
            </div>
            <div class="btm_text">{{ $t("main.text671") }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDirectorList, card_getConfig, getUserInfo } from "@/api/api";

export default {
  data() {
    return {
      apply_card_dlg: false,
      card_fee_dlg: false,
      check_num: "1",
      select_num: "",
      select_list: [],
      director_id: "",
      feb_config: {},
      company_name: "",
      kyc_status: "",
      u_id: sessionStorage.getItem("userid"),
      // company_type 0 链接申请卡正常显示 1去掉card-name等字段
      // company_type 0 正常链接申请  1 ruiying  2 aispoet 3 白标
      company_type: sessionStorage.getItem("company_type"),
      // cardTypeList:[],
      cardTypeList_type1: [],
      cardTypeList_type2: [],
      company_abbreviation: "",
      // 白标
      project_name: "",
    };
  },
  mounted() {
    // this.get_fee_api();
    // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
    this.kyc_status = sessionStorage.getItem("kyc_status");
    this.get_user_info();
    // company_attributes:1,属性 1普通合同2API合同3白标合同//API合同没有applynow和copy link
  },
  methods: {
    card_dlg_open(item) {
      // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
      if (this.kyc_status && this.kyc_status != 4) {
        return this.message.ismessage("error", this.$t("main.text599"));
      }
      localStorage.setItem("x_card_type", item.card_type);
      localStorage.setItem("x_card_level", item.card_level);
      localStorage.setItem("x_card_company_type", item.card_company_type);

      this.apply_card_dlg = true;
      this.select_num = "";
      // 卡片类型 1 FEB Debit Card 2 BETH Debit Card
      localStorage.setItem("card_type", "1");
      getDirectorList().then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          this.select_list = res.data.data;
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
      sessionStorage.setItem("x_apply_id", item.apply_id);
      sessionStorage.setItem("card_level_name", item.card_level_name);
      sessionStorage.setItem("company_attributes", item.company_attributes);
    },
    select_fun(id) {
      // console.log(id);
      this.director_id = id;
      let select_data = {};
      for (let i = 0; i < this.select_list.length; i++) {
        if (this.select_list[i].director_id == id) {
          select_data = this.select_list[i];
        }
      }
      // console.log(select_data);

      localStorage.setItem("director_data", JSON.stringify(select_data));
    },
    checkbox_fun(v) {
      v;
      // console.log(v);
    },
    continue_btn() {
      if (this.check_num == 1) {
        if (!this.select_num) {
          this.message.ismessage("error", this.$t("main.text500"));
          return false;
        }
        // 股东跳转
        // occupation	Number	1 Director 2 Staff
        // director_id	Number	director信息列表 里的 director_id
        localStorage.setItem("occupation_type", "1");
        localStorage.setItem("director_id", this.director_id);
        this.$router.push({ path: "/apply_card_input", query: { type: "1" } });
      } else if(this.check_num == 2) {
        // 普通员工跳转
        localStorage.setItem("occupation_type", "2");
        localStorage.setItem("director_id", "");
        this.$router.push({ path: "/apply_card_input", query: { type: "2" } });
      } else if(this.check_num == 3) {
        // 1 Director 2 Associates  3 Staff
        // Staff
        localStorage.setItem("occupation_type", "3");
        localStorage.setItem("director_id", "");
        this.$router.push({ path: "/apply_card_input", query: { type: "3" } });
      }
    },
    card_fee_btn(item) {
      this.get_fee_api(
        item.card_company_type,
        item.card_level,
        item.card_type,
        item.company_attributes
      );
      // this.card_fee_dlg=true;
    },
    get_fee_api(card_company_type, card_level, card_type, company_attributes) {
      card_getConfig({
        card_company_type,
        card_level,
        card_type,
        company_attributes,
      }).then((res) => {
        if (res.data.code == 200) {
          this.feb_config = res.data.data.feb_config;
          this.card_fee_dlg = true;
        } else {
          this.message.ismessage("error", res.data.msg);
        }
      });
    },
    copy_link(item) {
      // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
      if (this.kyc_status && this.kyc_status != 4) {
        return this.message.ismessage("error", this.$t("main.text599"));
      }
      this.copy_api(item.applyUrl);
    },

    //复制
    copy_api(v) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", v);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      document.body.removeChild(input);
      this.message.ismessage("success", this.$t("main.text297"));
      // this.$message.success("复制成功");
    },
    open_addr() {
      window.open("https://finexteasternbank.com/debit-cards-plan/", "_blank");
    },
    get_user_info() {
      getUserInfo().then((res) => {
        if (res.data.code == 200) {
          // 2023-06-08
          // company_type 0 链接申请卡正常显示 1去掉card-name等字段
          this.$nextTick(function () {
            this.company_type = res.data.data.company_type;
            this.company_name = res.data.data.company_name;
            sessionStorage.setItem("company_type", res.data.data.company_type);
            this.project_name = res.data.data.project_name;
          });

          // this.cardTypeList = res.data.data.cardTypeList;
          let list = res.data.data.cardTypeList;
          for (const key of list) {
            if (key.card_company_type == 1) {
              this.cardTypeList_type1.push(key);
              // 白标
              // if(this.company_type!=3){
              //     this.cardTypeList_type1.push(key);
              // }else{
              //     this.cardTypeList_type1=[];
              // }
            } else {
              this.cardTypeList_type2.push(key);
            }
          }
          // // 白标
          // if(this.company_type==3){
          //     this.cardTypeList_type1=[];
          // }
          this.company_abbreviation = res.data.data.company_abbreviation;
          sessionStorage.setItem(
            "company_attributes",
            res.data.data.company_attributes
          );
          // console.log(res.data.data);
        }
      });
    },
  },
};
</script>

<style scoped>
.home_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 16px;
}
.card_box1 {
  border-radius: 16px;
  color: #fff;
  margin-top: 95px;
  display: inline-block;
  max-width: 32%;
  min-width: 290px;
  margin-right: 1%;
}
.card_box1_top {
  height: 70px;
  background: #223c58;
  position: relative;
  border-radius: 16px 16px 0 0;
}
.card_box1_top_img {
  width: 80%;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  /* height: 194px; */
  z-index: 2;
}
.card_box1_bottom {
  background: #04182a;
  box-sizing: border-box;
  padding: 16px 28px 28px;
  border-radius: 0 0 16px 16px;
  position: relative;
  z-index: 2;
}
.btm_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btm_t2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.8;
  margin-bottom: 16px;
}
.btm_t3 {
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #deb981;
  box-sizing: border-box;
  padding: 0 32px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  cursor: pointer;
  border: 1.5px solid #deb981;
  border-radius: 4px;
  display: inline-block;
}
.card_row {
  /* margin: 10% 0 40px; */
  margin-bottom: 20px;
}
@media screen and (min-width: 1600px) {
  .card_box1_top {
    height: 85px;
  }
}
.card_info_icon {
  font-size: 18px;
  margin-left: 10px;
  cursor: pointer;
}
.c_img2 {
  border-radius: 8px 8px 0 0;
}
.btm_t3_2 {
  color: #8393a5;
  border-color: #8393a5;
}
.c2_box {
  box-sizing: border-box;
  padding: 0 13%;
}
.c2_box_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: #ffffff;
  opacity: 0.48;
}
.c2_box_t2 {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: #ffffff;
  opacity: 0.4;
}
.card_img1 {
  width: 39px;
}
.card_dlg_t1 {
  text-align: center;
}
.card_dlg_t2 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  margin-top: 17px;
}
.confirm_btn_card,
.confirm_btn_card:hover,
.confirm_btn_card:focus,
.confirm_btn_card:active {
  min-width: 144px;
  margin-top: 12px;
}
.btn_card {
  text-align: center;
}
.dlg_body {
  border-radius: 0 0 16px 16px;
}

/* 单选框 */
.list_table .el-radio {
  color: #fff;
}
.list_table >>> .el-radio__input.is-checked + .el-radio__label {
  color: #fff;
}
.list_table >>> .el-radio__input.is-checked .el-radio__inner,
.list_table >>> .el-radio__input.is-indeterminate .el-radio__inner {
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0px 0px 0px 2px #39526f inset;
}
.list_table >>> .el-radio__inner {
  border-radius: 50%;
  background: transparent;
  width: 24px;
  height: 24px;
}
.list_table >>> .el-radio__inner::after {
  display: none;
}
/* ------ */
.list_table {
  margin-top: 40px;
}
.c_radio_box {
  margin-bottom: 25px;
}
/* --- */

/* 费用 弹框表格 */
.c_fee_box {
  box-sizing: border-box;
  padding: 44px 68px;
}
.c_f_t1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
.c_b1 {
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #314b69;
  display: flex;
  flex-wrap: wrap;
}
.c_b2 {
  width: 50%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
}
.c_b3 {
  width: 50%;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
}
.c_b1_text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  opacity: 0.6;
  margin-top: 12px;
  word-break: break-word;
}

/* ------- */
.link_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.link_text {
  cursor: pointer;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #deb981;
  padding-right: 20px;
}
.btm_text {
  font-size: 15px;
  color: #ffffff;
  opacity: 0.6;
  text-align: right;
  padding-top: 10px;
}
.open_addr {
  cursor: pointer;
  color: #deb981;
  font-size: 12px;
}
.div_open_addr {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}
.type2_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  /* margin-bottom: 16px; */
  margin-bottom: 30px;
}
</style>

<style>
.card_dlg .el-dialog__body {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
.card_dlg .el-dialog__header {
  padding: 20px 20px 16px;
}
@media screen and (max-width: 850px) {
  .card_dlg_mobile {
    top: 5px;
    transform: translate(-50%, 0);
  }
}
</style>

<style scoped>
@media screen and (max-width: 1504px) {
  .btm_t3 {
    padding: 0 12px;
  }
}
@media screen and (min-width: 765px) and (max-width: 1390px) {
  .btm_t3,
  .link_text {
    font-size: 12px;
  }
}
@media screen and (max-width: 850px) {
  /* .card_box1 {
        margin: 90px 0 30px;
    } */
  .c_fee_box {
    padding: 25px 30px;
  }
  .c_b2 {
    width: 65%;
  }
  .c_b3 {
    width: 35%;
  }
  .card_box1 {
    max-width: 100%;
  }
}
</style>